<template>
  <div class="reward-list">
    <header>
      {{textConf.title}}
      <img src="~@/assets/images/ribbon.png" class="ribbon"/>
    </header>
    <main>
      <div class="reward-item" v-for="(item, index) in list" :key="index">
        <img :src="item.avatar" class="avatar">
        <div class="info-detail">
          <p class="main-info">{{item.phone}}</p>
          <p class="suport-info">{{item.time}}</p>
          <span class="right-info">+{{item.amountSplit.display}}</span>
        </div>
      </div>
    </main>
    <footer v-show="textConf.footer">{{textConf.footer}}</footer>
  </div>
</template>
<script>
export default {
  name: 'rewardList',
  props: {
    textConf: {
      type: Object,
      default: () => {
        return {
          title: '',
          footer: ''
        }
      }
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/main"
.reward-list
  padding 0 0 36px 32px
  background #FFFFFF
  border-radius 12px
  .ribbon
    position absolute
    width 82px
    top 0
    right 0
  header
    position relative
    padding 44px 0 41px
    font-family 'Aspira Medium'
    text-align center
    font-size 32px
    line-height 38px
    color #000000
    border-bottom 1px solid #E6E6E6
  main
    .reward-item
      padding 24px 32px 24px 0
      display flex
      align-items center
      justify-content flex-start
      img[src=""], img:not([src])
        opacity 0
      .avatar
        margin-right 24px
        width 82px
        border-radius 41px
        border 1px solid #EEEEEE
      .info-detail
        position relative
        width 100%
        .right-info
          position absolute
          top 50%
          right 0
          transform translate(0, -50%)
          font-family 'Aspira Light'
          font-size 32px
          color #000000
          line-height 32px
        .main-info
          margin-bottom 8px
          font-family 'Aspira Medium'
          font-size 32px
          color #000000
          line-height 34px
        .suport-info
          font-family 'Aspira Light'
          font-size 28px
          color #000000
          line-height 28px
  footer
    padding 48px 0 24px
    text-align center
    font-family 'Aspira Light'
    font-size 24px
    color #999999
    line-height 28px
</style>